import { clearGaTrafficType } from "./gaTrafficType";
import { clearGaUserId } from "./gaUserId";
import { clearGaUserProperties } from "./gaUserProperties";

/**
 * Signs the member out of Keycloak. Every sign-out in the dashboard goes through here (GROWTH-8102; a guard in
 * keycloakLogout.test.js keeps it that way), so the GA4 User-ID, user properties (GROWTH-8133) and traffic type
 * (GROWTH-8134) are cleared before Keycloak navigates away.
 */
export const logoutOfKeycloak = (keycloak, options) => {
  clearGaUserId();
  clearGaUserProperties();
  clearGaTrafficType();

  return keycloak.logout(options);
};
